const config = {
    development: {
      API_BASE_URL_L: "http://127.0.0.1:8000/",
      API_BASE_URL: "https://z-ninth-integrations-django-dev-001-atfzcwaygsfnf9bf.centralus-01.azurewebsites.net/",
    },
    production: {
      API_BASE_URL_OLD: "https://astronode-h2a5fsfxc3fkapef.centralus-01.azurewebsites.net/",
      API_BASE_URL: "https://z-ninth-integrations-django-dev-001-atfzcwaygsfnf9bf.centralus-01.azurewebsites.net/",
    },
  };
 
  const environment = process.env.NODE_ENV || "development"; // Default to 'development' if NODE_ENV is not set
  const currentConfig = config[environment];
 
  export default currentConfig;